import { doc, writeBatch } from 'firebase/firestore';
import { ICartProductPOS } from '~/interfaces/ICartProduct';
import IProduct from '~/interfaces/IProduct';
import { bff } from '~/services/bff';
import { DB } from '~/services/firebase';

const { REACT_APP_FIREBASE_PROJECT } = process.env;

export async function updateInventoryOfProductsSold(
  products: ICartProductPOS[],
): Promise<void> {
  const batch = writeBatch(DB);
  const productsUpdateds = await getProductsUpdated();

  products.forEach(product => {
    const find = productsUpdateds.find(item => item.uid === product.product_id);

    if (find && find.stok) {
      const productRef = doc(DB, 'products', find.uid);
      batch.update(productRef, { stok: find.stok - product.quantity });
    }
  });

  await batch.commit();
}

export async function getProductsUpdated(): Promise<IProduct[]> {
  try {
    await bff.delete(`/products/${REACT_APP_FIREBASE_PROJECT}`);
    const response = await bff.get(`/products/${REACT_APP_FIREBASE_PROJECT}`);
    await bff.delete(`/products/${REACT_APP_FIREBASE_PROJECT}`);
    return response.data;
  } catch (err) {
    console.log(err);
    return [];
  }
}